<div class="heading">
  <div class="col text-centre">
    <div *ngIf="environment.isB2E;">
      <h2 class="title-lg">
        Inventory Campaign Details (Internal View): {{dealer}} - {{grpdesc}}
      </h2>
    </div>
    <div *ngIf="environment.isB2D;">
      <h2 class="title-lg">
        Inventory Campaign Details (Dealer View): {{dealer}} - {{grpdesc}}
      </h2>
    </div>
  </div>
</div>
<app-api-ds-message></app-api-ds-message>
<br />
<div class="card">
  <ds-box
    [detachFooter]="true"
    class="dynamic-box"
    style="display: block; width: 100%; max-width: 100%"
  >
    <ds-box-content>
      <div *ngIf="environment.isB2E">
        <form [ds-form]="centerIDForm" [formGroup]="centerIDForm">
          <div class="row">
            <div class="col d-flex align-items-center mb-2x">
              <div class="col-sm-4 col-lg-3 mb-2x">
                <ds-form-field>
                  <label ds-label for="centerID"> Enter Center ID </label>
                  <input
                    ds-input
                    ds-form-validation
                    class="w-100"
                    id="centerID"
                    type="text"
                    placeholder="Insert Center ID"
                    formControlName="centerID"
                    maxlength="5"
                  />
                  <ds-hint> Enter a valid Center ID to proceed. </ds-hint>
                  <ds-error
                    *ngIf="centerIDForm.controls['centerID'].hasError('required')"
                  >
                    This field is required</ds-error
                  >
                  <ds-error
                    *ngIf="centerIDForm.controls['centerID'].hasError('pattern')"
                  >
                    Invalid Center ID</ds-error
                  >
                </ds-form-field>
              </div>
              <div class="mb-2x" style="margin-left: 4rem">
                <button
                  ds-button
                  ds-button-primary
                  ds-loading
                  [isLoading]="isCenterIDLoading"
                  loadingVariant="indeterminate"
                  icon="search"
                  type="submit"
                  (click)="onSearch()"
                >
                  Search
                </button>
              </div>
            </div>
            <ds-skeleton
              variant="text"
              textStyle="title-lg"
              [hasShimmer]="isCenterIDLoading"
            >
            </ds-skeleton>
          </div>
        </form>
      </div>
      <ds-accordion>
        <ds-accordion-item id="accordion-item">
          Filters:
          <div content>
            <form [ds-form]="criteria" [formGroup]="criteria">
              <div class="row">
                <div class="row row-cols-1 row-cols-lg-5 gx-3 gy-2">
                  <div class="col col-lg-3 mb-2x">
                    <ds-form-field>
                      <label ds-label for="CampaignType">Campaign Type:</label>
                      <ds-select
                        class="w-100"
                        id="CampaignType"
                        formControlName="CampaignType"
                        isMultiselect
                        [options]="CampaignTypeItems"
                        [labellingConfig]="{placeholder: displaySelection('CampaignType')}"
                        (selectionChange)="onSelectionChange('CampaignType', $event)"
                      ></ds-select>
                      <ds-hint
                        >Selected: {{ displaySelection('CampaignType')
                        }}</ds-hint
                      >
                    </ds-form-field>
                  </div>
                  <div class="col col-lg-3 mb-2x">
                    <ds-form-field>
                      <label ds-label for="LineMake">Line Make:</label>
                      <ds-select
                        class="w-100"
                        id="LineMake"
                        formControlName="LineMake"
                        isMultiselect
                        [options]="LineMakeItems"
                        [labellingConfig]="{placeholder: displaySelection('LineMake')}"
                        (selectionChange)="onSelectionChange('LineMake', $event)"
                      ></ds-select>
                      <ds-hint
                        >Selected: {{ displaySelection('LineMake') }}</ds-hint
                      >
                    </ds-form-field>
                  </div>
                  <div class="col col-lg-3 mb-2x">
                    <ds-form-field>
                      <label ds-label for="EngineeringSeries"
                        >Engineering Series:</label
                      >
                      <ds-select
                        class="w-100"
                        id="EngineeringSeries"
                        formControlName="EngineeringSeries"
                        isMultiselect
                        [options]="EngineeringSeriesItems"
                        [labellingConfig]="{placeholder: displaySelection('EngineeringSeries')}"
                        (selectionChange)="onSelectionChange('EngineeringSeries', $event)"
                      ></ds-select>
                      <ds-hint
                        >Selected: {{ displaySelection('EngineeringSeries')
                        }}</ds-hint
                      >
                    </ds-form-field>
                  </div>
                  <div class="col col-lg-3 mb-2x">
                    <ds-form-field>
                      <label ds-label for="ModelYear">Model Year:</label>
                      <ds-select
                        class="w-100"
                        id="ModelYear"
                        formControlName="ModelYear"
                        isMultiselect
                        [options]="ModelYearItems"
                        [labellingConfig]="{placeholder: displaySelection('ModelYear')}"
                        (selectionChange)="onSelectionChange('ModelYear', $event)"
                      ></ds-select>
                      <ds-hint
                        >Selected: {{ displaySelection('ModelYear') }}</ds-hint
                      >
                    </ds-form-field>
                  </div>
                  <div class="col col-lg-3 mb-2x">
                    <ds-form-field>
                      <label ds-label for="Location">Location:</label>
                      <ds-select
                        class="w-100"
                        id="Location"
                        formControlName="Location"
                        isMultiselect
                        [options]="LocationItems"
                        [labellingConfig]="{placeholder: displaySelection('Location')}"
                        (selectionChange)="onSelectionChange('Location', $event)"
                      ></ds-select>
                      <ds-hint
                        >Selected: {{ displaySelection('Location') }}</ds-hint
                      >
                    </ds-form-field>
                  </div>
                </div>
              </div>
              <ds-skeleton
                variant="text"
                textStyle="title-lg"
                [hasShimmer]="isMultiSelected"
              >
              </ds-skeleton>
              <div class="title-md mb-2x">Sub Filters:</div>
              <div class="row">
                <div class="row row-cols-1 row-cols-lg-3 gx-lg-5 gy-2">
                  <div class="col col-lg-3 mb-2x">
                    <ds-form-field>
                      <label ds-label for="VehicleCampaignStatus"
                        >Vehicle Campaign Status:
                      </label>
                      <ds-select
                        class="w-100"
                        id="VehicleCampaignStatus"
                        formControlName="VehicleCampaignStatus"
                        [options]="VehicleCampaignStatusItems"
                        (selectionChange)="onSelectionChange('VehicleCampaignStatus', $event)"
                      ></ds-select>
                    </ds-form-field>
                  </div>
                  <div class="col col-lg-3 mb-2x">
                    <ds-form-field>
                      <label ds-label for="LoanerVehicleCount"
                        >Demo / Loaner Vehicle Count:</label
                      >
                      <ds-select
                        class="w-100"
                        id="LoanerVehicleCount"
                        formControlName="LoanerVehicleCount"
                        [options]="LoanerVehicleCountItems"
                        (selectionChange)="onSelectionChange('LoanerVehicleCount', $event)"
                      ></ds-select>
                    </ds-form-field>
                  </div>
                  <div class="col col-lg-3 mb-2x d-flex align-items-center">
                    <ds-link
                      href="#"
                      label="Clear Selection Criteria"
                      (click)="onClearSelection(); $event.preventDefault();"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </ds-accordion-item>
      </ds-accordion>
      <ds-skeleton
        variant="text"
        textStyle="title-lg"
        [hasShimmer]="isSingleSelected"
      >
      </ds-skeleton>
      <ds-accordion>
        <ds-accordion-item id="accordion-item1">
          <div class="title-md mb-2x headingColor">Selected Criteria:</div>
          <div content>
            <div class="row">
              <div
                class="row row-cols-1 row-cols-lg-3 gx-lg-5 gy-2 selected-criteria-row"
              >
                <h3 class="col selected-criteria-item">
                  Campaign Type: {{ criteria.get('CampaignType')?.value}}
                </h3>
                <h3 class="col selected-criteria-item">
                  Line Make: {{ criteria.get('LineMake')?.value }}
                </h3>
                <h3 class="col selected-criteria-item">
                  Vehicle Campaign Status: {{
                  criteria.get('VehicleCampaignStatus')?.value }}
                </h3>
                <h3 class="col selected-criteria-item">
                  Engineering Series: {{
                  criteria.get('EngineeringSeries')?.value }}
                </h3>
                <h3 class="col selected-criteria-item">
                  Model Year: {{ criteria.get('ModelYear')?.value }}
                </h3>
                <h3 class="col selected-criteria-item">
                  Demo / Loaner Vehicle Count: {{
                  criteria.get('LoanerVehicleCount')?.value }}
                </h3>
                <h3 class="col selected-criteria-item">
                  Location: {{ criteria.get('Location')?.value }}
                </h3>
              </div>
            </div>
            <!-- <ds-link href="#" label="Clear Selection Criteria" (click)="onClearSelection(); $event.preventDefault();" /> -->
            <!-- <div class="info-actions mt-3">
              <h3 class="mb-0">Details as of : {{ currentDate }} at {{ currentTime }}</h3>
              <ds-button ds-button-secondary icon="refresh" class="refresh-btn" (click)="onRefresh()"> Refresh
              </ds-button>
            </div> -->
          </div>
        </ds-accordion-item>
      </ds-accordion>
    </ds-box-content>
  </ds-box>
  <br />
</div>
